'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../../../styleInject.js');

var css_248z = ".ItemAdditionalInfoForm-module_textarea__Lqyj0{display:flex;min-height:200px;width:100%}";
var styles = {"textarea":"ItemAdditionalInfoForm-module_textarea__Lqyj0"};
styleInject["default"](css_248z, '91698ebc-1917-4286-96f2-4834faa30e3a');

exports["default"] = styles;
